import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./index.css";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import CardTable from "../CardTable";
import TripsTable from "../TripsTable";
import LedgerTable from "../LedgerTable";
import SalaryTable from "../SalaryTable";
import SvgImage from "../../../Icons/Icons";
import ManageDriverAddBalance from "../../../Modals/ManageDriverAddBalance";
import ManageDriverWithdrawBalance from "../../../Modals/ManageDriverWithdrawBalance";
import NoDriverSelected from "../../../../Components/ManageDriver/SubComponents/NewDriverSideSection/SubComponents/NoDriverSelected";
import {
  getTripsNew,
  clearTripList,
} from "../../../../services/Store/Actions/TripsAction";
import { Button, Modal, ModalBody } from "reactstrap";

import Attendence from "./Attendence";
import VehicleList from "../../../ManageDriver/VehicleList";
import CardControlsModal from "../../../Modals/CardControlsModal";
import { newGetCardControlAction } from "../../../../services/Store/Actions/driverslistActions";
import NeoCredCard from "../NeoCredCard";
import YesbankCard from "../NeoCredCard";
import { is } from "date-fns/locale";
import InventoryTable from "../InventoryTable";
import BulkTransfer from "../BulkTransfer";

import AddDriverBulk from "../AddDriverBulk";
import AddDriverModal from "../AddDriver";
const DriverMain = (props) => {
  //////
  const [bulkSalary, setBulkSalary] = useState(false);
  const [userIdFix, setUserIdFix] = useState(null);
  const [addDriver, setAddDriver] = useState(false);
  const [send, setSend] = useState(false);
  const [bulkAdd, setBulkAdd] = useState(false);
  const [inventory, setInventory] = useState(false);

  const showModalAddDriver = () => {
    setSend(false);
    setAddDriver(true);
  };
  const toggleModalAddDriver = () => {
    setAddDriver(!addDriver);
  };

  const openInventory = () => {
    setInventory(true);
  };
  //////
  const dispatch = useDispatch();
  let { id } = useParams();
  let { state, location } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const offset = searchParams.get("offset");
  const search = searchParams.get("search");
  const [selected, setSelected] = useState(0);
  let { tripsCount, tripsListNew } = useSelector((store) => store?.trip);
  const { allDriversAdvance, allDriverListAdvance, driverListLoader } =
    useSelector((state) => state?.driverlist);
  const driver = allDriverListAdvance?.find((elem) => elem?.userId == id);
  console.log(allDriverListAdvance, "driverdriverdriverdriver", driver);
  if (!state?.driver) {
    console.log("idididdddd", id);
  }
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  //const [proceed, setProceed] = useState(0);

  const toggleModal = () => {
    setOpen(!open);
    // setProceed(0);
  };

  const handleClose = () => {
    setOpen(false);
    // setProceed(0);
  };

  const handleShow = () => {
    setOpen(true);
  };
  const [Attedence, setshowAttedence] = useState(false);
  const showAttendence = () => {
    setshowAttedence(!Attedence);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const toggleModal2 = () => {
    setOpen2(!open2);
  };

  const showModal2 = () => {
    setOpen2(true);
  };

  //handle add to card transfer
  const [open3, setOpen3] = useState(false);

  const handleClose3 = () => {
    setOpen3(false);
  };

  const toggleModal3 = () => {
    setOpen3(!open3);
  };

  const showModal3 = () => {
    setOpen3(true);
  };

  const [open4, setOpen4] = useState(false);

  const handleClose4 = () => {
    setOpen4(false);
  };

  const toggleModal4 = () => {
    setOpen4(!open4);
  };

  const showModal4 = () => {
    setOpen4(true);
  };
  const [open5, setOpen5] = useState(false);

  const handleClose5 = () => {
    setOpen5(false);
  };

  const toggleModal5 = () => {
    setOpen5(!open5);
  };

  const showModal5 = () => {
    setOpen5(true);
  };
  useEffect(() => {
    if (id !== "" && id !== undefined && id !== null) {
      props.setUserIdFix(null);
      dispatch(
        getTripsNew({
          offset: 0,
          limit: 10,
          driverId: id,
          // startTime: moment(startDate).format("MM/DD/YYYY"),
          // endTime: moment(endDate).format("MM/DD/YYYY"),
          // search: search,
          // status: status,
        })
      );

      dispatch(newGetCardControlAction(id));
    } else {
      dispatch(clearTripList());
    }
  }, [id]);

  // const {driver} = state
  const bal = driver?.walletBalance?.toFixed(2) || "N/A";
  return (
    <div
      className="contMain"
      style={{ background: "#FFFFFF", padding: "12px 0px 0px 25px" }}
    >
      <div className="row">
        {/* Transfer Driver Bulk  */}
        <div
          className="FUllListSearchBar col-lg-5 leftTopDiv  FullDriverDashboardBox"
          onClick={() => {
            console.log("bulkSalarybulkSalary11", bulkSalary);
            setBulkSalary(!bulkSalary);
          }}
          style={{ margin: "10px 12px 20px 11px", cursor: "pointer" }}
        >
          <div className="bulkSalarySvgHeading">
            <div
              style={{
                backgroundColor: "#FFF",
                padding: "4px",
                borderRadius: "4px",
                marginRight: "10px",
              }}
            >
              <SvgImage name="payBulkSalaryLogo" />
            </div>
            <div className="FontNS18">Transfer Driver Bulk</div>
          </div>
          <SvgImage name="rightArrow" />
        </div>
        {bulkSalary ? <BulkTransfer /> : <></>}

        {/* Add Driver Bulk  */}

        <div
          className="FUllListSearchBar col-lg-5 leftTopDiv "
          onClick={() => {
            console.log("bulkSalarybulkSalary11", bulkAdd);
            setBulkAdd(!bulkAdd);
          }}
          style={{ margin: "10px 12px 20px 11px", cursor: "pointer" }}
        >
          <div className="bulkSalarySvgHeading">
            <div
              style={{
                backgroundColor: "#FFF",
                padding: "4px",
                borderRadius: "4px",
                marginRight: "10px",
              }}
            >
              <SvgImage name="payBulkSalaryLogo" />
            </div>
            <div className="FontNS18">Add Driver Bulk</div>
          </div>
          <SvgImage name="rightArrow" />
        </div>
        {bulkAdd ? <AddDriverBulk /> : <></>}
      </div>

      {/* //// inventory  */}
      <div className="row">
        <div
          className="FUllListSearchBar col-lg-5 leftTopDiv"
          onClick={() => {
            console.log("bulkSalarybulkSalary11", inventory);
            setInventory(!inventory);
          }}
          style={{ margin: "10px 12px 20px 11px", cursor: "pointer" }}
        >
          <div className="bulkSalarySvgHeading">
            <div
              style={{
                backgroundColor: "#FFF",
                padding: "4px",
                borderRadius: "4px",
                marginRight: "10px",
              }}
            >
              <SvgImage name="creditCard" />
            </div>
            <div className="FontNS18">Inventory</div>
          </div>
          <SvgImage name="rightArrow" />
        </div>

        {/* Add Driver  */}
        <div
          className="FUllListSearchBar col-lg-5 leftTopDiv "
          onClick={() => {
            setUserIdFix(null);
            showModalAddDriver();
          }}
          style={{ margin: "10px 12px 20px 11px", cursor: "pointer" }}
        >
          <div className="bulkSalarySvgHeading">
            <div
              style={{
                backgroundColor: "#FFF",
                padding: "4px",
                borderRadius: "4px",
                marginRight: "10px",
              }}
            >
              <SvgImage name="payBulkSalaryLogo" />
            </div>
            <div className="FontNS18">Add Driver</div>
          </div>
          <SvgImage name="rightArrow" />
        </div>
      </div>

      {/* ////////////////////////////////////////////////////////////////  */}

      {/* {props.inventory ? ( */}
      {inventory ? (
        <>
          <div className="flexStyling">
            <button className={"ButtonNew"} onClick={() => setSelected(0)}>
              Inventory
            </button>
            {/* <button
              className={selected == 3 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(3)}
            >
              Salary & Incentive
            </button> */}
          </div>
          <div className="boxTxn1" style={{ marginRight: "15px" }}>
            <InventoryTable
              selected={selected}
              userId={id}
              // inventoryStatus={props.inventory}
              inventoryStatus={inventory}
            />
          </div>
        </>
      ) : !driver ? (
        <NoDriverSelected />
      ) : (
        <>
          <div
            className="fontNB24"
            style={{
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div className="row" style={{ margin: 0 }}>
              <div className="col-8 row" style={{ paddingTop: "14px" }}>
                <div className="col-12">
                  {driver?.fullName?.toUpperCase()}{" "}
                  <span>
                    {driver?.vrn ? <text> ({driver?.vrn} )</text> : ""}
                  </span>
                  {driver?.driverCode ? (
                    <div className="col-12 fontNR16">
                      Driver Code : {driver?.driverCode}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div
                className="col-4 padding8 padding16T driverCardColor flexStyling"
                style={{ borderRadius: "0 0.5rem 0.5rem 0" }}
                onClick={() => {
                  handleShow();
                }}
              >
                <SvgImage name="driverPageIconSmall" />
                <div className="padding8L padding8R">
                  <div className="Regular heading4">Assigned Vehicle</div>
                  <div
                    className={
                      driver?.vrn == null
                        ? "Bold heading4"
                        : driver?.vrn == "Driver not selected"
                        ? "Bold heading4"
                        : "Bold heading3"
                    }
                  >
                    {driver?.vrn == null ? "Yet to be Assigned" : driver?.vrn}
                  </div>
                </div>
                <SvgImage name="editLogo" width="18" height="18" />
                <div
                  className="semiBold heading4 greenFont"
                  style={{ cursor: "pointer" }}
                >
                  Change
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className="col-5"
                style={{
                  display: "flex",
                  padding: "8px 0 0 21px",
                  flexDirection: "row",
                  flex: 1,
                  alignItems: "center",
                }}
                onClick={() => {
                  console.log("Click");
                  showAttendence();
                }}
              >
                <div
                  className="outside-Truck-logo-for-total-vehicle"
                  style={{
                    textAlign: "center",
                    paddingTop: "3px",
                    marginLeft: "3px",
                    marginTop: "7px",
                  }}
                >
                  <SvgImage
                    name="cash1"
                    classname="Truck-logo-for-total-vehicle"
                  />
                </div>
                <div
                  style={{
                    padding: "5px",
                  }}
                >
                  Attendence
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ margin: "15px 0 25px 0" }}>
            <div className="col-md-4" style={{ padding: "5px" }}>
              <div
                className="cardInfo3"
                // style={{margin: "20px 0px 30px 0px"}}
              >
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="driverHeader" style={{ color: "#4D5073" }}>
                    Card Balance
                  </div>
                  {driver?.walletAccountStatus == 4 ? (
                    <div
                      style={{ fontSize: 12, cursor: "pointer" }}
                      onClick={showModal5}
                    >
                      Details <SvgImage name="rightArrow" />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="driverHeader">
                  {driver?.walletAccountStatus < 3
                    ? "No card"
                    : driver?.walletAccountStatus == 3
                    ? "Card Not Linked"
                    : bal === null
                    ? "₹ 0"
                    : "₹ " + bal}
                </div>
                {driver?.walletAccountStatus == 4 ? (
                  <div
                    className="flexStyling"
                    style={{ justifyContent: "space-between" }}
                  >
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={showModal3}
                      disabled={driver?.walletAccountStatus == 4 ? false : true}
                    >
                      Recharge
                    </button>
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={showModal2}
                      disabled={driver?.walletAccountStatus == 4 ? false : true}
                    >
                      Withdraw
                    </button>
                  </div>
                ) : driver?.walletAccountStatus < 3 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      onClick={() => {
                        let tmp = driver?.fullName?.split(" ");
                        console.log("jjishihihsihsei", tmp);
                        props.setUserIdFix({
                          userId: id,
                          firstName: tmp[0],
                          lastName: tmp.length < 2 ? "" : tmp[tmp?.length - 1],
                          phone: driver?.phone,
                        });
                        props.showModalAddDriver();
                      }}
                    >
                      Complete Min KYC
                    </Button>
                  </div>
                ) : driver?.walletAccountStatus == 6 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      style={{ width: "250px" }}
                    >
                      Min KYC Completed. Proceed with Full KYC on LogiPe App
                    </Button>
                  </div>
                ) : driver?.walletAccountStatus == 3 ? (
                  <Button
                    type="submit"
                    className="col-5 Button9"
                    style={{ width: "250px" }}
                  >
                    KYC Completed. Proceed with Link Card on LogiPe App
                  </Button>
                ) : driver?.walletAccountStatus == 15 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      style={{ width: "250px" }}
                    >
                      Card is Locked.
                    </Button>
                  </div>
                ) : driver?.walletAccountStatus == 12 ? (
                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      className="col-5 Button9"
                      style={{ width: "250px" }}
                    >
                      Card is Blocked. Please Replace the New Card
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="col-md-4" style={{ padding: "5px" }}>
              <div className="cardInfo3">
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="driverHeader" style={{ color: "#4D5073" }}>
                    Driver Details
                  </div>
                  <div
                    style={{ fontSize: 12, cursor: "pointer" }}
                    onClick={showModal4}
                  >
                    Details
                    <SvgImage name="rightArrow" />
                  </div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Vehicle No</div>
                  <div className="fontNM16">{driver?.vrn}</div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Current Trip</div>
                  <div className="fontNM16">
                    {driver?.currentTrip ? driver?.currentTrip : "TR-0120"}
                  </div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNM16">Phone</div>
                  <div className="fontNM16">{driver?.phone}</div>
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ padding: "5px" }}>
              <div className=" cardInfo3">
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    className="vehicleHeaderV2 col-8"
                    style={{ color: "#4D5073" }}
                  >
                    Performance{" "}
                    {props.sideBar ? (
                      <></>
                    ) : (
                      <span style={{ fontSize: 12, paddingTop: "5px" }}>
                        (this month)
                      </span>
                    )}
                  </div>
                  <div
                    className="col-4"
                    style={{ fontSize: 12, textAlign: "end" }}
                  >
                    Details
                    <SvgImage name="rightArrow" />
                  </div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNR16">Total Trips</div>
                  <div className="">{tripsCount || 0}</div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNR16">Payout Done</div>
                  <div className="">34500</div>
                </div>
                <div
                  className="flexStyling"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="fontNR16">Kms Travelled</div>
                  <div className="">100</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flexStyling">
            <button
              className={selected == "0" ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => {
                console.log("mkjeoj", selected);
                setSelected("0");
              }}
            >
              Card
            </button>
            <button
              className={selected == 1 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(1)}
            >
              Trips
            </button>
            <button
              className={selected == 2 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(2)}
            >
              Ledger
            </button>
            {/* <button
              className={selected == 3 ? "ButtonNew" : "ButtonNewInactive"}
              onClick={() => setSelected(3)}
            >
              Salary & Incentive
            </button> */}
          </div>
          <div className="boxTxn1" style={{ marginRight: "15px" }}>
            {selected == "0" ? (
              <CardTable selected={selected} userId={id} />
            ) : selected == 1 ? (
              <TripsTable
                selected={selected}
                userId={id}
                driverName={driver?.fullName}
                accountStatus={driver?.walletAccountStatus}
              />
            ) : selected === 2 ? (
              <LedgerTable
                selected={selected}
                userId={id}
                driverName={driver?.fullName}
                accountStatus={driver?.walletAccountStatus}
              />
            ) : selected === 3 ? (
              <SalaryTable selected={selected} userId={id} />
            ) : (
              <></>
            )}
          </div>
          <Modal
            isOpen={open}
            onHide={handleClose}
            className="PGCollection-modal"
            toggle={toggleModal}
            aria-labelledby="myModalLabel2"
          >
            {/* <Button
            type="button"
            className="close-btn"
            onClick={toggleModal}
            aria-label="Close"
          >
            <SvgImage name="CloseButtonLogo" />
          </Button> */}
            <ModalBody style={{ paddingTop: "0", width: "950px" }}>
              <div className="PGCollectionBox">
                <div
                  className=/*"PGCollectionclose */ "row close-btn-for-transaction padding16T"
                  onClick={toggleModal}
                >
                  <div className="col-10"></div>
                  <div className="col-1" style={{ textAlign: "right" }}>
                    <SvgImage
                      classname="close-btn-text"
                      style={{ width: "10%", height: "10%" }}
                      name="CloseButtonLogo"
                      width="20%"
                      height="20%"
                    />
                  </div>
                  <div className="col-1 padding0L">Close</div>
                </div>
                <VehicleList
                  setVehicleNumber={driver?.vrn}
                  driverID={id}
                  handleClick={handleClose}
                  toggleModal={toggleModal}
                />
              </div>
            </ModalBody>
          </Modal>
          {open3 ? (
            <ManageDriverAddBalance
              open={open3}
              toggleModal={toggleModal3}
              handleClose={handleClose3}
              name="Add Balance"
              userId={id}
              driverBal={bal}
              cardType={1}
              driverName={driver?.fullName}
              offset={offset}
              search={search}
            />
          ) : (
            <></>
          )}

          {open2 ? (
            <ManageDriverWithdrawBalance
              open={open2}
              toggleModal={toggleModal2}
              handleClose={handleClose2}
              name="Withdraw Balance"
              userId={id}
              driverBal={bal}
              cardType={1}
              driverDetails={{ ...driver, name: driver?.fullName }}
              driverName={driver?.fullName}
              offset={offset}
              search={search}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {/* {
           props.bulkSalary ? <BulkTransfer/> :  !driver ? <NoDriverSelected /> :      
           <div className="col-lg-9 FullDriverDashboardBox">
          <DriverMain
          />
          </div>
        } */}
      {Attedence ? (
        <Attendence
          toggle={showAttendence}
          modal={Attedence}
          setModal={setshowAttedence}
          regNo={"props.regNo"}
          fleetId={"id"}
          userId={id}
          phone={driver?.phone}
          name={driver?.fullName}
          // customerId={customerId}
        />
      ) : (
        <></>
      )}

      {open4 ? (
        <CardControlsModal
          userId={id}
          open={open4}
          toggleModal={toggleModal4}
          title="Logipe Account"
          handleClose={handleClose4}
          cardType={"1"}
          accountStatus={driver?.walletAccountStatus}
          authUser={props.authUser}
          phone={driver?.phone}
        />
      ) : null}
      {open5 ? (
        <YesbankCard
          open={open5}
          onHide={toggleModal5}
          // remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
          toggleModal={toggleModal5}
          handleClose={handleClose5}
          userId={id}
          driverCardStatus={driver?.walletAccountStatus}
          driverDetails={driver?.fullName}
        />
      ) : null}

      <AddDriverModal
        toggle={toggleModalAddDriver}
        modal={addDriver}
        setModal={setAddDriver}
        setUserIdFix={setUserIdFix}
        userIdFix={userIdFix}
        send={send}
        setSend={setSend}
      />
    </div>
  );
};

export default DriverMain;
